/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetSubscriberCommand
 */
export interface SetSubscriberCommand {
    /**
     * 
     * @type {string}
     * @memberof SetSubscriberCommand
     */
    subscriberId: string;
}

/**
 * Check if a given object implements the SetSubscriberCommand interface.
 */
export function instanceOfSetSubscriberCommand(value: object): value is SetSubscriberCommand {
    if (!('subscriberId' in value) || value['subscriberId'] === undefined) return false;
    return true;
}

export function SetSubscriberCommandFromJSON(json: any): SetSubscriberCommand {
    return SetSubscriberCommandFromJSONTyped(json, false);
}

export function SetSubscriberCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetSubscriberCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'subscriberId': json['subscriberId'],
    };
}

export function SetSubscriberCommandToJSON(json: any): SetSubscriberCommand {
    return SetSubscriberCommandToJSONTyped(json, false);
}

export function SetSubscriberCommandToJSONTyped(value?: SetSubscriberCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subscriberId': value['subscriberId'],
    };
}

